import { Input } from "design-system/atoms/Input"
import { Textarea } from "design-system/atoms/Textarea"
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "design-system/organisms/Form"
import { FieldValues, Path, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"

type Props<T extends FieldValues> = {
  form: UseFormReturn<T>
  translationPrefix?: string
  showDescription?: boolean
}

export function GeneralSection<T extends FieldValues>({
  form,
  translationPrefix = "webhookConfig",
  showDescription = false,
}: Props<T>) {
  const { t } = useTranslation()

  return (
    <div className="border rounded-lg bg-secondary p-4 flex flex-col gap-4">
      <FormField
        control={form.control}
        name={"name" as Path<T>}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t(`capabilities.${translationPrefix}.name.label`)}</FormLabel>
            <FormControl>
              <Input
                placeholder={t(`capabilities.${translationPrefix}.name.placeholder`)}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      {showDescription && (
        <FormField
          control={form.control}
          name={"description" as Path<T>}
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t(`capabilities.${translationPrefix}.serverDescription.label`)}
              </FormLabel>
              <FormControl>
                <Textarea
                  {...field}
                  placeholder={t(`capabilities.${translationPrefix}.serverDescription.placeholder`)}
                  rows={2}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  )
}
